import styled from 'styled-components'
import FormScreenImage from './Images/jatoform.png'

export const StyledJATOFormScreen = styled.div`
  .splashScreen {
    background: no-repeat url(${FormScreenImage});
    min-height: 770px;
    background-size: cover;
  }
`
